import { ReactComponent as CheckIcon } from "../../../../assets/icons/check.svg";
import F01 from "../../../../assets/images/f1.png";
import F02 from "../../../../assets/images/f2.png";
import F03 from "../../../../assets/images/f3.png";
import F04 from "../../../../assets/images/f4.png";
import F05 from "../../../../assets/images/f5.png";

const FeaturesSection = () => {
  return (
    <div className="min-h-screen p-4 sm:p-6 py-8 sm:py-14">
      <div className="max-w-[95vw] lg:max-w-[85vw] mx-auto">
        {/* Feature 1 - Vehicle Tracking & Monitoring */}
        <div className="flex flex-col lg:flex-row items-center justify-between lg:space-x-12 xl:space-x-24 mt-8 sm:mt-16 lg:mt-28 border border-[#CECECE] rounded-[12px] sm:rounded-[20px] min-h-[400px] sm:min-h-[500px] lg:h-[678px] overflow-hidden">
          <div className="w-full lg:w-[759px] flex flex-col items-start justify-center p-4 sm:p-6 lg:pl-8 order-2 lg:order-1">
            <div className="p-2 sm:p-4">
              <h1 className="text-[24px] sm:text-[32px] lg:text-[45px] font-semibold text-hColor leading-tight">
                Vehicle Tracking & Monitoring
              </h1>
              <p className="text-pColor text-[14px] sm:text-[16px] lg:text-[20px] my-4 sm:my-6 lg:my-8">
                Gain complete visibility and control over your fleet with
                real-time vehicle tracking and monitoring. Fleet Pro enables you
                to track vehicle locations and trip history with GPS precision,
                ensuring you always know where your assets are. Receive alerts
                when vehicles enter or exit designated areas and track speed to
                ensure driver compliance.
              </p>
              <div className="space-y-4 sm:space-y-6 lg:space-y-8 text-[14px] sm:text-[16px] lg:text-[20px] font-normal text-pColor">
                <div className="flex space-x-3 items-center">
                  <CheckIcon className="flex-shrink-0" />
                  <span>Fuel consumption monitoring to cut costs.</span>
                </div>
                <div className="flex space-x-3 items-center">
                  <CheckIcon className="flex-shrink-0" />
                  <span>Real-time GPS tracking with geofencing.</span>
                </div>
                <div className="flex space-x-3 items-center">
                  <CheckIcon className="flex-shrink-0" />
                  <span>Detailed trip history and analytics.</span>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[800px] h-[250px] sm:h-[350px] lg:h-[678px] order-1 lg:order-2">
            <img src={F01} alt="Vehicle Dashboard" className="w-full h-full" />
          </div>
        </div>

        {/* Feature 2 - Driver Management & Trip Analytics */}
        <div className="flex flex-col lg:flex-row items-center justify-between lg:space-x-12 xl:space-x-24 mt-8 sm:mt-16 lg:mt-28 border border-[#CECECE] rounded-[12px] sm:rounded-[20px] min-h-[400px] sm:min-h-[500px] lg:h-[678px] overflow-hidden">
          <div className="w-full lg:w-[759px] flex flex-col items-start justify-center p-4 sm:p-6 lg:pl-8 order-2 lg:order-1">
            <div className="p-2 sm:p-4">
              <h1 className="text-[24px] sm:text-[32px] lg:text-[45px] font-semibold text-hColor leading-tight">
                Driver Management & Trip Analytics
              </h1>
              <p className="text-pColor text-[14px] sm:text-[16px] lg:text-[20px] my-4 sm:my-6 lg:my-8">
                Gain full visibility into your drivers' performance and trip
                activities with real-time tracking, automated trip logs, and
                route optimization. Fleet Pro ensures accountability, improves
                efficiency, and helps reduce operational costs by providing
                insights into driver behavior, fuel usage, and trip history.
              </p>
              <div className="space-y-4 sm:space-y-6 lg:space-y-8 text-[14px] sm:text-[16px] lg:text-[20px] font-normal text-pColor">
                <div className="flex space-x-3 items-center">
                  <CheckIcon className="flex-shrink-0" />
                  <span>Assign vehicles to drivers and their trips.</span>
                </div>
                <div className="flex space-x-3 items-center">
                  <CheckIcon className="flex-shrink-0" />
                  <span>Driver performance reports to improve efficiency.</span>
                </div>
                <div className="flex space-x-3 items-center">
                  <CheckIcon className="flex-shrink-0" />
                  <span>Automated trip logging for accurate data.</span>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[800px] h-[250px] sm:h-[350px] lg:h-[678px] order-1 lg:order-2">
            <img src={F02} alt="Vehicle Dashboard" className="w-full h-full" />
          </div>
        </div>

        {/* Feature 3 - Maintenance Management */}
        <div className="flex flex-col lg:flex-row items-center justify-between lg:space-x-12 xl:space-x-24 mt-8 sm:mt-16 lg:mt-28 border border-[#CECECE] rounded-[12px] sm:rounded-[20px] min-h-[400px] sm:min-h-[500px] lg:h-[678px] overflow-hidden">
          <div className="w-full lg:w-[759px] flex flex-col items-start justify-center p-4 sm:p-6 lg:pl-8 order-2 lg:order-1">
            <div className="p-2 sm:p-4">
              <h1 className="text-[24px] sm:text-[32px] lg:text-[45px] font-semibold text-hColor leading-tight">
                Maintenance Management
              </h1>
              <p className="text-pColor text-[14px] sm:text-[16px] lg:text-[20px] my-4 sm:my-6 lg:my-8">
                Fleet Pro helps you prevent unexpected breakdowns by providing
                real-time alerts for scheduled servicing, inspections, and
                urgent repairs. Track maintenance history, set automated
                reminders for oil changes, tire rotations, and part
                replacements, and ensure your vehicles stay roadworthy.
              </p>
              <div className="space-y-4 sm:space-y-6 lg:space-y-8 text-[14px] sm:text-[16px] lg:text-[20px] font-normal text-pColor">
                <div className="flex space-x-3 items-center">
                  <CheckIcon className="flex-shrink-0" />
                  <span>
                    Instant alerts for repairs, servicing, and fuel levels.
                  </span>
                </div>
                <div className="flex space-x-3 items-center">
                  <CheckIcon className="flex-shrink-0" />
                  <span>Automated maintenance scheduling.</span>
                </div>
                <div className="flex space-x-3 items-center">
                  <CheckIcon className="flex-shrink-0" />
                  <span>Real-time GPS tracking with geofencing.</span>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[800px] h-[250px] sm:h-[350px] lg:h-[678px] order-1 lg:order-2">
            <img src={F03} alt="Vehicle Dashboard" className="w-full h-full" />
          </div>
        </div>

        {/* Feature 4 - Profit & Expense Monitoring */}
        <div className="flex flex-col lg:flex-row items-center justify-between lg:space-x-12 xl:space-x-24 mt-8 sm:mt-16 lg:mt-28 border border-[#CECECE] rounded-[12px] sm:rounded-[20px] min-h-[400px] sm:min-h-[500px] lg:h-[678px] overflow-hidden">
          <div className="w-full lg:w-[759px] flex flex-col items-start justify-center p-4 sm:p-6 lg:pl-8 order-2 lg:order-1">
            <div className="p-2 sm:p-4">
              <h1 className="text-[24px] sm:text-[32px] lg:text-[45px] font-semibold text-hColor leading-tight">
                Profit & Expense Monitoring
              </h1>
              <p className="text-pColor text-[14px] sm:text-[16px] lg:text-[20px] my-4 sm:my-6 lg:my-8">
                Keep track of your fleet's financial performance with real-time
                profit and expense monitoring. Fleet Pro provides detailed
                insights into revenue, fuel costs, maintenance expenses, and
                other operational costs, helping you identify areas to cut waste
                and maximize profitability.
              </p>
              <div className="space-y-4 sm:space-y-6 lg:space-y-8 text-[14px] sm:text-[16px] lg:text-[20px] font-normal text-pColor">
                <div className="flex space-x-3 items-center">
                  <CheckIcon className="flex-shrink-0" />
                  <span>Track earnings per vehicle.</span>
                </div>
                <div className="flex space-x-3 items-center">
                  <CheckIcon className="flex-shrink-0" />
                  <span>
                    Expense breakdown for fuel, maintenance, and more.
                  </span>
                </div>
                <div className="flex space-x-3 items-center">
                  <CheckIcon className="flex-shrink-0" />
                  <span>Financial reports for better decision-making.</span>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[800px] h-[250px] sm:h-[350px] lg:h-[678px] order-1 lg:order-2">
            <img src={F04} alt="Vehicle Dashboard" className="w-full h-full" />
          </div>
        </div>

        {/* Feature 5 - Reporting & Analytics */}
        <div className="flex flex-col lg:flex-row items-center justify-between lg:space-x-12 xl:space-x-24 mt-8 sm:mt-16 lg:mt-28 border border-[#CECECE] rounded-[12px] sm:rounded-[20px] min-h-[400px] sm:min-h-[500px] lg:h-[678px] overflow-hidden">
          <div className="w-full lg:w-[759px] flex flex-col items-start justify-center p-4 sm:p-6 lg:pl-8 order-2 lg:order-1">
            <div className="p-2 sm:p-4">
              <h1 className="text-[24px] sm:text-[32px] lg:text-[45px] font-semibold text-hColor leading-tight">
                Reporting & analytics
              </h1>
              <p className="text-pColor text-[14px] sm:text-[16px] lg:text-[20px] my-4 sm:my-6 lg:my-8">
                Make smarter fleet decisions with real-time analytics and
                automated reports. Fleet Pro provides in-depth insights into
                vehicle performance, driver behavior, fuel efficiency, and
                maintenance trends. With our comprehensive analytics, you can
                identify cost-saving opportunities, optimize routes, and predict
                maintenance needs.
              </p>
              <div className="space-y-4 sm:space-y-6 lg:space-y-8 text-[14px] sm:text-[16px] lg:text-[20px] font-normal text-pColor">
                <div className="flex space-x-3 items-center">
                  <CheckIcon className="flex-shrink-0" />
                  <span>Customizable dashboards with key fleet metrics.</span>
                </div>
                <div className="flex space-x-3 items-center">
                  <CheckIcon className="flex-shrink-0" />
                  <span>Downloadable reports for performance tracking.</span>
                </div>
                <div className="flex space-x-3 items-center">
                  <CheckIcon className="flex-shrink-0" />
                  <span>Insights for cost reduction and optimization..</span>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[800px] h-[250px] sm:h-[350px] lg:h-[678px] order-1 lg:order-2">
            <img src={F05} alt="Vehicle Dashboard" className="w-full h-full" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesSection;
//  sm:object-cover object-none
